import React from "react";
import Icon from "@ant-design/icons";


const StaffInfoSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M37.99,4.59H10.16c-3.63,0-6.58,2.95-6.58,6.58v26.76c0,3.63,2.95,6.58,6.58,6.58h27.83c3.63,0,6.58-2.95,6.58-6.58V11.17c0-3.63-2.95-6.58-6.58-6.58ZM41.57,37.93c0,1.97-1.61,3.58-3.58,3.58H10.16c-1.97,0-3.58-1.61-3.58-3.58V11.17c0-1.97,1.61-3.58,3.58-3.58h27.83c1.97,0,3.58,1.61,3.58,3.58v26.76Z" />
        <path d="M28.16,20.69c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-8.16c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h2.58v11.52h-2.58c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h8.16c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-2.58v-11.52h2.58Z" />
        <path d="M24.04,16.36c1.03,0,1.87-.84,1.87-1.87s-.84-1.87-1.87-1.87-1.87.84-1.87,1.87.84,1.87,1.87,1.87Z" />
    </svg>
);

const StaffInfoIcon = (props) => <Icon { ...props } component={ StaffInfoSvg } />;

export default StaffInfoIcon;
